// countriesList.ts
import { i18n } from '@/i18n';

export interface Country {
  code: string;
  dialCode: string;
  flag: string;
}

/**
 * Get translated country name
 * @param countryCode - ISO country code (e.g., 'FR', 'US')
 * @returns Translated country name
 */
export const getCountryName = (countryCode: string): string => i18n.global.t(`countries.codes.${countryCode}`) as string;

export const countriesList: Country[] = [
  {
    code: 'AF', dialCode: '+93', flag: '🇦🇫',
  },
  {
    code: 'AX', dialCode: '+358', flag: '🇦🇽',
  },
  {
    code: 'AL', dialCode: '+355', flag: '🇦🇱',
  },
  {
    code: 'DZ', dialCode: '+213', flag: '🇩🇿',
  },
  {
    code: 'AS', dialCode: '+1', flag: '🇦🇸',
  },
  {
    code: 'AD', dialCode: '+376', flag: '🇦🇩',
  },
  {
    code: 'AO', dialCode: '+244', flag: '🇦🇴',
  },
  {
    code: 'AI', dialCode: '+1', flag: '🇦🇮',
  },
  {
    code: 'AQ', dialCode: '+672', flag: '🇦🇶',
  },
  {
    code: 'AG', dialCode: '+1', flag: '🇦🇬',
  },
  {
    code: 'AR', dialCode: '+54', flag: '🇦🇷',
  },
  {
    code: 'AM', dialCode: '+374', flag: '🇦🇲',
  },
  {
    code: 'AW', dialCode: '+297', flag: '🇦🇼',
  },
  {
    code: 'AU', dialCode: '+61', flag: '🇦🇺',
  },
  {
    code: 'AT', dialCode: '+43', flag: '🇦🇹',
  },
  {
    code: 'AZ', dialCode: '+994', flag: '🇦🇿',
  },
  {
    code: 'BS', dialCode: '+1', flag: '🇧🇸',
  },
  {
    code: 'BH', dialCode: '+973', flag: '🇧🇭',
  },
  {
    code: 'BD', dialCode: '+880', flag: '🇧🇩',
  },
  {
    code: 'BB', dialCode: '+1', flag: '🇧🇧',
  },
  {
    code: 'BY', dialCode: '+375', flag: '🇧🇾',
  },
  {
    code: 'BE', dialCode: '+32', flag: '🇧🇪',
  },
  {
    code: 'BZ', dialCode: '+501', flag: '🇧🇿',
  },
  {
    code: 'BJ', dialCode: '+229', flag: '🇧🇯',
  },
  {
    code: 'BM', dialCode: '+1', flag: '🇧🇲',
  },
  {
    code: 'BT', dialCode: '+975', flag: '🇧🇹',
  },
  {
    code: 'BO', dialCode: '+591', flag: '🇧🇴',
  },
  {
    code: 'BQ', dialCode: '+599', flag: '🇧🇶',
  },
  {
    code: 'BA', dialCode: '+387', flag: '🇧🇦',
  },
  {
    code: 'BW', dialCode: '+267', flag: '🇧🇼',
  },
  {
    code: 'BR', dialCode: '+55', flag: '🇧🇷',
  },
  {
    code: 'IO', dialCode: '+246', flag: '🇮🇴',
  },
  {
    code: 'VG', dialCode: '+1', flag: '🇻🇬',
  },
  {
    code: 'BN', dialCode: '+673', flag: '🇧🇳',
  },
  {
    code: 'BG', dialCode: '+359', flag: '🇧🇬',
  },
  {
    code: 'BF', dialCode: '+226', flag: '🇧🇫',
  },
  {
    code: 'BI', dialCode: '+257', flag: '🇧🇮',
  },
  {
    code: 'KH', dialCode: '+855', flag: '🇰🇭',
  },
  {
    code: 'CM', dialCode: '+237', flag: '🇨🇲',
  },
  {
    code: 'CA', dialCode: '+1', flag: '🇨🇦',
  },
  {
    code: 'CV', dialCode: '+238', flag: '🇨🇻',
  },
  {
    code: 'KY', dialCode: '+1', flag: '🇰🇾',
  },
  {
    code: 'CF', dialCode: '+236', flag: '🇨🇫',
  },
  {
    code: 'TD', dialCode: '+235', flag: '🇹🇩',
  },
  {
    code: 'CL', dialCode: '+56', flag: '🇨🇱',
  },
  {
    code: 'CN', dialCode: '+86', flag: '🇨🇳',
  },
  {
    code: 'CX', dialCode: '+61', flag: '🇨🇽',
  },
  {
    code: 'CC', dialCode: '+61', flag: '🇨🇨',
  },
  {
    code: 'CO', dialCode: '+57', flag: '🇨🇴',
  },
  {
    code: 'KM', dialCode: '+269', flag: '🇰🇲',
  },
  {
    code: 'CG', dialCode: '+242', flag: '🇨🇬',
  },
  {
    code: 'CD', dialCode: '+243', flag: '🇨🇩',
  },
  {
    code: 'CK', dialCode: '+682', flag: '🇨🇰',
  },
  {
    code: 'CR', dialCode: '+506', flag: '🇨🇷',
  },
  {
    code: 'CI', dialCode: '+225', flag: '🇨🇮',
  },
  {
    code: 'HR', dialCode: '+385', flag: '🇭🇷',
  },
  {
    code: 'CU', dialCode: '+53', flag: '🇨🇺',
  },
  {
    code: 'CW', dialCode: '+599', flag: '🇨🇼',
  },
  {
    code: 'CY', dialCode: '+357', flag: '🇨🇾',
  },
  {
    code: 'CZ', dialCode: '+420', flag: '🇨🇿',
  },
  {
    code: 'DK', dialCode: '+45', flag: '🇩🇰',
  },
  {
    code: 'DJ', dialCode: '+253', flag: '🇩🇯',
  },
  {
    code: 'DM', dialCode: '+1', flag: '🇩🇲',
  },
  {
    code: 'DO', dialCode: '+1', flag: '🇩🇴',
  },
  {
    code: 'EC', dialCode: '+593', flag: '🇪🇨',
  },
  {
    code: 'EG', dialCode: '+20', flag: '🇪🇬',
  },
  {
    code: 'SV', dialCode: '+503', flag: '🇸🇻',
  },
  {
    code: 'GQ', dialCode: '+240', flag: '🇬🇶',
  },
  {
    code: 'ER', dialCode: '+291', flag: '🇪🇷',
  },
  {
    code: 'EE', dialCode: '+372', flag: '🇪🇪',
  },
  {
    code: 'SZ', dialCode: '+268', flag: '🇸🇿',
  },
  {
    code: 'ET', dialCode: '+251', flag: '🇪🇹',
  },
  {
    code: 'FK', dialCode: '+500', flag: '🇫🇰',
  },
  {
    code: 'FO', dialCode: '+298', flag: '🇫🇴',
  },
  {
    code: 'FJ', dialCode: '+679', flag: '🇫🇯',
  },
  {
    code: 'FI', dialCode: '+358', flag: '🇫🇮',
  },
  {
    code: 'FR', dialCode: '+33', flag: '🇫🇷',
  },
  {
    code: 'GF', dialCode: '+594', flag: '🇬🇫',
  },
  {
    code: 'PF', dialCode: '+689', flag: '🇵🇫',
  },
  {
    code: 'TF', dialCode: '+262', flag: '🇹🇫',
  },
  {
    code: 'GA', dialCode: '+241', flag: '🇬🇦',
  },
  {
    code: 'GM', dialCode: '+220', flag: '🇬🇲',
  },
  {
    code: 'GE', dialCode: '+995', flag: '🇬🇪',
  },
  {
    code: 'DE', dialCode: '+49', flag: '🇩🇪',
  },
  {
    code: 'GH', dialCode: '+233', flag: '🇬🇭',
  },
  {
    code: 'GI', dialCode: '+350', flag: '🇬🇮',
  },
  {
    code: 'GR', dialCode: '+30', flag: '🇬🇷',
  },
  {
    code: 'GL', dialCode: '+299', flag: '🇬🇱',
  },
  {
    code: 'GD', dialCode: '+1', flag: '🇬🇩',
  },
  {
    code: 'GP', dialCode: '+590', flag: '🇬🇵',
  },
  {
    code: 'GU', dialCode: '+1', flag: '🇬🇺',
  },
  {
    code: 'GT', dialCode: '+502', flag: '🇬🇹',
  },
  {
    code: 'GG', dialCode: '+44', flag: '🇬🇬',
  },
  {
    code: 'GN', dialCode: '+224', flag: '🇬🇳',
  },
  {
    code: 'GW', dialCode: '+245', flag: '🇬🇼',
  },
  {
    code: 'GY', dialCode: '+592', flag: '🇬🇾',
  },
  {
    code: 'HT', dialCode: '+509', flag: '🇭🇹',
  },
  {
    code: 'HN', dialCode: '+504', flag: '🇭🇳',
  },
  {
    code: 'HK', dialCode: '+852', flag: '🇭🇰',
  },
  {
    code: 'HU', dialCode: '+36', flag: '🇭🇺',
  },
  {
    code: 'IS', dialCode: '+354', flag: '🇮🇸',
  },
  {
    code: 'IN', dialCode: '+91', flag: '🇮🇳',
  },
  {
    code: 'ID', dialCode: '+62', flag: '🇮🇩',
  },
  {
    code: 'IR', dialCode: '+98', flag: '🇮🇷',
  },
  {
    code: 'IQ', dialCode: '+964', flag: '🇮🇶',
  },
  {
    code: 'IE', dialCode: '+353', flag: '🇮🇪',
  },
  {
    code: 'IM', dialCode: '+44', flag: '🇮🇲',
  },
  {
    code: 'IL', dialCode: '+972', flag: '🇮🇱',
  },
  {
    code: 'IT', dialCode: '+39', flag: '🇮🇹',
  },
  {
    code: 'JM', dialCode: '+1', flag: '🇯🇲',
  },
  {
    code: 'JP', dialCode: '+81', flag: '🇯🇵',
  },
  {
    code: 'JE', dialCode: '+44', flag: '🇯🇪',
  },
  {
    code: 'JO', dialCode: '+962', flag: '🇯🇴',
  },
  {
    code: 'KZ', dialCode: '+7', flag: '🇰🇿',
  },
  {
    code: 'KE', dialCode: '+254', flag: '🇰🇪',
  },
  {
    code: 'KI', dialCode: '+686', flag: '🇰🇮',
  },
  {
    code: 'XK', dialCode: '+383', flag: '🇽🇰',
  },
  {
    code: 'KW', dialCode: '+965', flag: '🇰🇼',
  },
  {
    code: 'KG', dialCode: '+996', flag: '🇰🇬',
  },
  {
    code: 'LA', dialCode: '+856', flag: '🇱🇦',
  },
  {
    code: 'LV', dialCode: '+371', flag: '🇱🇻',
  },
  {
    code: 'LB', dialCode: '+961', flag: '🇱🇧',
  },
  {
    code: 'LS', dialCode: '+266', flag: '🇱🇸',
  },
  {
    code: 'LR', dialCode: '+231', flag: '🇱🇷',
  },
  {
    code: 'LY', dialCode: '+218', flag: '🇱🇾',
  },
  {
    code: 'LI', dialCode: '+423', flag: '🇱🇮',
  },
  {
    code: 'LT', dialCode: '+370', flag: '🇱🇹',
  },
  {
    code: 'LU', dialCode: '+352', flag: '🇱🇺',
  },
  {
    code: 'MO', dialCode: '+853', flag: '🇲🇴',
  },
  {
    code: 'MG', dialCode: '+261', flag: '🇲🇬',
  },
  {
    code: 'MW', dialCode: '+265', flag: '🇲🇼',
  },
  {
    code: 'MY', dialCode: '+60', flag: '🇲🇾',
  },
  {
    code: 'MV', dialCode: '+960', flag: '🇲🇻',
  },
  {
    code: 'ML', dialCode: '+223', flag: '🇲🇱',
  },
  {
    code: 'MT', dialCode: '+356', flag: '🇲🇹',
  },
  {
    code: 'MH', dialCode: '+692', flag: '🇲🇭',
  },
  {
    code: 'MQ', dialCode: '+596', flag: '🇲🇶',
  },
  {
    code: 'MR', dialCode: '+222', flag: '🇲🇷',
  },
  {
    code: 'MU', dialCode: '+230', flag: '🇲🇺',
  },
  {
    code: 'YT', dialCode: '+262', flag: '🇾🇹',
  },
  {
    code: 'MX', dialCode: '+52', flag: '🇲🇽',
  },
  {
    code: 'FM', dialCode: '+691', flag: '🇫🇲',
  },
  {
    code: 'MD', dialCode: '+373', flag: '🇲🇩',
  },
  {
    code: 'MC', dialCode: '+377', flag: '🇲🇨',
  },
  {
    code: 'MN', dialCode: '+976', flag: '🇲🇳',
  },
  {
    code: 'ME', dialCode: '+382', flag: '🇲🇪',
  },
  {
    code: 'MS', dialCode: '+1', flag: '🇲🇸',
  },
  {
    code: 'MA', dialCode: '+212', flag: '🇲🇦',
  },
  {
    code: 'MZ', dialCode: '+258', flag: '🇲🇿',
  },
  {
    code: 'MM', dialCode: '+95', flag: '🇲🇲',
  },
  {
    code: 'NA', dialCode: '+264', flag: '🇳🇦',
  },
  {
    code: 'NR', dialCode: '+674', flag: '🇳🇷',
  },
  {
    code: 'NP', dialCode: '+977', flag: '🇳🇵',
  },
  {
    code: 'NL', dialCode: '+31', flag: '🇳🇱',
  },
  {
    code: 'NC', dialCode: '+687', flag: '🇳🇨',
  },
  {
    code: 'NZ', dialCode: '+64', flag: '🇳🇿',
  },
  {
    code: 'NI', dialCode: '+505', flag: '🇳🇮',
  },
  {
    code: 'NE', dialCode: '+227', flag: '🇳🇪',
  },
  {
    code: 'NG', dialCode: '+234', flag: '🇳🇬',
  },
  {
    code: 'NU', dialCode: '+683', flag: '🇳🇺',
  },
  {
    code: 'NF', dialCode: '+672', flag: '🇳🇫',
  },
  {
    code: 'KP', dialCode: '+850', flag: '🇰🇵',
  },
  {
    code: 'MK', dialCode: '+389', flag: '🇲🇰',
  },
  {
    code: 'MP', dialCode: '+1', flag: '🇲🇵',
  },
  {
    code: 'NO', dialCode: '+47', flag: '🇳🇴',
  },
  {
    code: 'OM', dialCode: '+968', flag: '🇴🇲',
  },
  {
    code: 'PK', dialCode: '+92', flag: '🇵🇰',
  },
  {
    code: 'PW', dialCode: '+680', flag: '🇵🇼',
  },
  {
    code: 'PS', dialCode: '+970', flag: '🇵🇸',
  },
  {
    code: 'PA', dialCode: '+507', flag: '🇵🇦',
  },
  {
    code: 'PG', dialCode: '+675', flag: '🇵🇬',
  },
  {
    code: 'PY', dialCode: '+595', flag: '🇵🇾',
  },
  {
    code: 'PE', dialCode: '+51', flag: '🇵🇪',
  },
  {
    code: 'PH', dialCode: '+63', flag: '🇵🇭',
  },
  {
    code: 'PL', dialCode: '+48', flag: '🇵🇱',
  },
  {
    code: 'PT', dialCode: '+351', flag: '🇵🇹',
  },
  {
    code: 'PR', dialCode: '+1', flag: '🇵🇷',
  },
  {
    code: 'QA', dialCode: '+974', flag: '🇶🇦',
  },
  {
    code: 'RE', dialCode: '+262', flag: '🇷🇪',
  },
  {
    code: 'RO', dialCode: '+40', flag: '🇷🇴',
  },
  {
    code: 'RU', dialCode: '+7', flag: '🇷🇺',
  },
  {
    code: 'RW', dialCode: '+250', flag: '🇷🇼',
  },
  {
    code: 'BL', dialCode: '+590', flag: '🇧🇱',
  },
  {
    code: 'SH', dialCode: '+290', flag: '🇸🇭',
  },
  {
    code: 'KN', dialCode: '+1', flag: '🇰🇳',
  },
  {
    code: 'LC', dialCode: '+1', flag: '🇱🇨',
  },
  {
    code: 'MF', dialCode: '+590', flag: '🇲🇫',
  },
  {
    code: 'PM', dialCode: '+508', flag: '🇵🇲',
  },
  {
    code: 'VC', dialCode: '+1', flag: '🇻🇨',
  },
  {
    code: 'WS', dialCode: '+685', flag: '🇼🇸',
  },
  {
    code: 'SM', dialCode: '+378', flag: '🇸🇲',
  },
  {
    code: 'ST', dialCode: '+239', flag: '🇸🇹',
  },
  {
    code: 'SA', dialCode: '+966', flag: '🇸🇦',
  },
  {
    code: 'SN', dialCode: '+221', flag: '🇸🇳',
  },
  {
    code: 'RS', dialCode: '+381', flag: '🇷🇸',
  },
  {
    code: 'SC', dialCode: '+248', flag: '🇸🇨',
  },
  {
    code: 'SL', dialCode: '+232', flag: '🇸🇱',
  },
  {
    code: 'SG', dialCode: '+65', flag: '🇸🇬',
  },
  {
    code: 'SX', dialCode: '+1', flag: '🇸🇽',
  },
  {
    code: 'SK', dialCode: '+421', flag: '🇸🇰',
  },
  {
    code: 'SI', dialCode: '+386', flag: '🇸🇮',
  },
  {
    code: 'SB', dialCode: '+677', flag: '🇸🇧',
  },
  {
    code: 'SO', dialCode: '+252', flag: '🇸🇴',
  },
  {
    code: 'ZA', dialCode: '+27', flag: '🇿🇦',
  },
  {
    code: 'GS', dialCode: '+500', flag: '🇬🇸',
  },
  {
    code: 'KR', dialCode: '+82', flag: '🇰🇷',
  },
  {
    code: 'SS', dialCode: '+211', flag: '🇸🇸',
  },
  {
    code: 'ES', dialCode: '+34', flag: '🇪🇸',
  },
  {
    code: 'LK', dialCode: '+94', flag: '🇱🇰',
  },
  {
    code: 'SD', dialCode: '+249', flag: '🇸🇩',
  },
  {
    code: 'SR', dialCode: '+597', flag: '🇸🇷',
  },
  {
    code: 'SJ', dialCode: '+47', flag: '🇸🇯',
  },
  {
    code: 'SE', dialCode: '+46', flag: '🇸🇪',
  },
  {
    code: 'CH', dialCode: '+41', flag: '🇨🇭',
  },
  {
    code: 'SY', dialCode: '+963', flag: '🇸🇾',
  },
  {
    code: 'TW', dialCode: '+886', flag: '🇹🇼',
  },
  {
    code: 'TJ', dialCode: '+992', flag: '🇹🇯',
  },
  {
    code: 'TZ', dialCode: '+255', flag: '🇹🇿',
  },
  {
    code: 'TH', dialCode: '+66', flag: '🇹🇭',
  },
  {
    code: 'TL', dialCode: '+670', flag: '🇹🇱',
  },
  {
    code: 'TG', dialCode: '+228', flag: '🇹🇬',
  },
  {
    code: 'TK', dialCode: '+690', flag: '🇹🇰',
  },
  {
    code: 'TO', dialCode: '+676', flag: '🇹🇴',
  },
  {
    code: 'TT', dialCode: '+1', flag: '🇹🇹',
  },
  {
    code: 'TN', dialCode: '+216', flag: '🇹🇳',
  },
  {
    code: 'TR', dialCode: '+90', flag: '🇹🇷',
  },
  {
    code: 'TM', dialCode: '+993', flag: '🇹🇲',
  },
  {
    code: 'TC', dialCode: '+1', flag: '🇹🇨',
  },
  {
    code: 'TV', dialCode: '+688', flag: '🇹🇻',
  },
  {
    code: 'UG', dialCode: '+256', flag: '🇺🇬',
  },
  {
    code: 'UA', dialCode: '+380', flag: '🇺🇦',
  },
  {
    code: 'AE', dialCode: '+971', flag: '🇦🇪',
  },
  {
    code: 'GB', dialCode: '+44', flag: '🇬🇧',
  },
  {
    code: 'US', dialCode: '+1', flag: '🇺🇸',
  },
  {
    code: 'UM', dialCode: '+1', flag: '🇺🇲',
  },
  {
    code: 'UY', dialCode: '+598', flag: '🇺🇾',
  },
  {
    code: 'UZ', dialCode: '+998', flag: '🇺🇿',
  },
  {
    code: 'VU', dialCode: '+678', flag: '🇻🇺',
  },
  {
    code: 'VA', dialCode: '+39', flag: '🇻🇦',
  },
  {
    code: 'VE', dialCode: '+58', flag: '🇻🇪',
  },
  {
    code: 'VN', dialCode: '+84', flag: '🇻🇳',
  },
  {
    code: 'VG', dialCode: '+1', flag: '🇻🇬',
  },
  {
    code: 'VI', dialCode: '+1', flag: '🇻🇮',
  },
  {
    code: 'WF', dialCode: '+681', flag: '🇼🇫',
  },
  {
    code: 'YE', dialCode: '+967', flag: '🇾🇪',
  },
  {
    code: 'ZM', dialCode: '+260', flag: '🇿🇲',
  },
  {
    code: 'ZW', dialCode: '+263', flag: '🇿🇼',
  },
];
